module.exports = __webpack_public_path__ + "img/image-collection-sliding-overlays-mitsu.7886293a.png";